<template>
  <v-card>
    <v-card-title class="justify-center">Choose Shipping Method</v-card-title>
    <v-card-text>
      <p class="body-1 text-center">
        Your package is scheduled to arrive on Island
        {{ estimatedArrivalDateByMethod }}.<br> Do you wish to proceed?
      </p>
			<v-radio-group v-model="shipmentMethod" inline :column="false">
				<v-radio value="ocean">
					<template v-slot:label>
						<div class="d-flex flex-column ">
							<div class="font-weight-bold text-subtitle-1">Ocean Shipping</div>
							<span class="text-caption">Arrives on {{ getFormattedDate(arrivalDate) }}</span>
						</div>
					</template>
				</v-radio>
				<v-radio value="air">
					<template v-slot:label>
						<div class="d-flex flex-column ">
							<div class="font-weight-bold text-subtitle-1">Air Shipping</div>
							<span class="text-caption">Arrives on {{ getFormattedDate(getAirShippmentArrivalDate()) }}</span>
						</div>
					</template>
				</v-radio>
			</v-radio-group>
      <v-row justify="center">
        <v-date-picker
          v-model="convertedArrivalDate"
          elevation="2"
          readonly
        ></v-date-picker>
      </v-row>
      <p style="color:red;font-weight: bold;margin-top:20px;margin-bottom:0;text-align: center;">Please allow 3-5 business days for Customs Clearance</p>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn outlined @click="closeDialog">Cancel</v-btn>
      <v-btn color="success" @click="submitForm" :loading="isWaitingForResponse"
        >Confirm</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import { DateTime } from "luxon";

export default {
  name: 'RequestShipmentForm',

  components: {
  },

  props: {
    selectedPackage: Object,
    arrivalDate: Object,
		timezone: String,
  },

  data: () => ({
    isWaitingForResponse: false,
    shipmentMethod: 'ocean',
  }),


  computed: {
    convertedArrivalDate: function () {
			if (this.shipmentMethod === 'ocean') 
				return this.arrivalDate.toISODate()
			return this.getAirShippmentArrivalDate().toISODate();
    },

		estimatedArrivalDateByMethod: function () {
			if (this.shipmentMethod === 'ocean') 
				return this.arrivalDate.toFormat("dd-MMM-yyyy")
			return this.getAirShippmentArrivalDate().toFormat("dd-MMM-yyyy");

		},
  },

  methods: {
    submitForm: function () {
      this.isWaitingForResponse = true
      const accessCode = this.$route.params.accessCode
      const data = {
        "shipmentRequested": true,
        "shipmentMethod": this.shipmentMethod,
        "estimatedArrivalDate": this.convertedArrivalDate,
      }
      let packageId = this.selectedPackage.id
      let packageObj = this.$store.state.packages.find(
        packageObj => packageObj.id === packageId
      )
      packageObj.waitingForUpdate = true
      this.$store.commit("updatePackage", packageObj)
      axios
        .patch(
          `${process.env.VUE_APP_API_ROOT_URL}packages/${accessCode}/${packageId}/`,
          data
        )
        .then(() => {
          packageObj.shipmentRequested = true
          packageObj.shipmentMethod = this.shipmentMethod
          packageObj.estimatedArrivalDate = this.convertedArrivalDate
          delete packageObj["waitingForUpdate"]
          this.$store.commit("updatePackage", packageObj)
          this.isWaitingForResponse = false
          this.closeDialog()
        })
        .catch(() => {
          delete packageObj["waitingForUpdate"]
          this.$store.commit("updatePackage", packageObj)
          this.isWaitingForResponse = false
        });
    },
    updateData: function () {
      this.$emit('update-data')
    },
    closeDialog: function () {
      this.$emit('close-dialog')
    },
    getFormattedDate: function (ISOString) {
      return DateTime.fromISO(ISOString).toFormat("MMM dd, yyyy");
    },

		getAirShippmentArrivalDate() {
			const monday = 1
			const thursday = 4
      let today = DateTime.now().setZone(this.timezone);
			let shipmentDay = today;

			let nextMonday = today.startOf('week').plus({ week: 1 });

			if (today.weekday == monday) {
				if (today.hour >= 17)
					shipmentDay = nextMonday.set({ weekday: thursday });
				else
					shipmentDay = today.set({ weekday: thursday });
			} else {
				shipmentDay = nextMonday.set({ weekday: thursday });
			}

			return shipmentDay
		},
  },
};
</script>
<style>
.v-input--radio-group__input{
  justify-content: space-evenly;
}
</style>